module.exports = __webpack_public_path__ + "static/media/artistic.de55fa4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artistic.jpg
// module id = 311
// module chunks = 0